import React from "react";
import { CashReceiptsFormViewForExtend } from "./CashReceiptsFormView";
import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { DocumentTypeCode } from "@odata/GeneratedEnums";

class CashReceiptsIssuedFormView extends CashReceiptsFormViewForExtend {
    documentTypeCode = DocumentTypeCode.CashReceiptIssued;
}

export default withPermissionContext(CashReceiptsIssuedFormView);